// extracted by mini-css-extract-plugin
export default {"periodFilter":"InjuryPeriodFilter_periodFilter__LOQ1K","chip":"InjuryPeriodFilter_chip__+dn0N","chipActive":"InjuryPeriodFilter_chipActive__+9ZfD"};